<template>
    <point-detail-list 
        ref="list"
        header-text="発行履歴"
        >
        <div v-if="getListObj">
            <div v-if="getListObj.data.length > 0">
                <div class="card mb-2" v-for="item in getListObj.data" :key="item.id">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item text-muted py-1">
                            <div class="d-flex align-items-center">
                                <span>
                                    <small> 決済番号&nbsp;{{item.pay_num}} </small>
                                </span>
                                <span class="flex-fill text-right let-space-1">
                                    {{toLocaleString(item.point_cnt)}}件
                                </span>
                            </div>
                        </li>
                        <li class="list-group-item pb-1 let-space-1">
                            <div class="d-flex align-items-center">
                                <span>
                                    <i class="fas fa-donate text-primary icon-size"></i>
                                </span>
                                <span class="flex-fill text-right">
                                    <b>{{toLocaleString(item.points)}}</b>P
                                </span>
                            </div>
                            <div class="text-right">
                                <small><small class="text-muted">{{item.start_time | dformatm}} ~ {{item.end_time | dformatm}}</small></small>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </point-detail-list>
</template>

<script>
    import PointDetailList from 'pages/commons/List/List'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PointDetailList
        },
        mounted () {
            this.$refs.list.loadListObj({
                url: 'invite.point.hist'
            })
        },
        computed: {
            ...mapGetters(['getListObj'])
        },
        methods: {
            toLocaleString (num) {
                return Number(num).toLocaleString()
            },
        }
    }
</script>
